import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppLoader } from "../hooks/useAppLoader";
import apiLinks from '../config/apiLinks.json';
import axios from 'axios';


const LoginPage = () => {
  const { showLoader } = useAppLoader(1600);
  const [username, setUsername] = useState('');
  const [otpPassword, setOtpPassword] = useState('');
  const [showOtpPassword, setShowOtpPassword] = useState(false);
  const [permanentPassword, setPermanentPassword] = useState('');
  const [changedPassword, setChangedPassword] = useState("0");
  const [showPermanentPassword, setShowPermanentPassword] = useState(false);
  const [repeatPassword, setRepeatPassword] = useState('');
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [counter, setCounter] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const [success, setSuccess] = useState("");
  const [infoText, setInfoText] = useState(
    'لطفا برای ورود کد مشتری خود را وارد کنید'
  );
  const { login, checkUser, loginByUserPassword, logout, ResendPassword } = useAuth();
  useEffect(() => {
    const hide = showLoader();
    setTimeout(() => hide(), 300);
  }, []);
  useEffect(() => {
    const mainElement = document.querySelector('.MuiBox-root.css-xq4xb4');
    if (mainElement) {
      mainElement.style.marginRight = '0px';
    }
    return () => {
      if (mainElement) {
        mainElement.style.marginRight = '';
      }
    };
  }, []);
  useEffect(() => {
    if (step !== 2) return;

    if (counter === 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [step, counter]);
  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  };
  const handleLoginByUserPassword = async () => {
    setLoading(true);
    setLoginError('');

    try {
      const result = await loginByUserPassword(username, permanentPassword);

      if (result && result.message) {
        setLoginError(result.message);
      }
    } catch (error) {
      setLoginError(error.message || "خطایی در ورود رخ داد");
    } finally {
      setLoading(false);
    }
  };
  const handleNextStep = async () => {
    if (!username) return;

    setLoading(true);
    setLoginError('');

    const result = await checkUser(username);

    if (result.success) {
      setChangedPassword(result.changedPassword)
      if (result.changedPassword?.toString() === '1') {
        setStep(3);
        setInfoText(`رمز عبور خود را وارد کنید`);
      }
      else {
        setStep(2);
        setCounter(120);
        setCanResend(false);
        setInfoText(`رمز عبور برای کد مشتری «${username}» ارسال شد.`);
      }
    } else {
      setLoginError(result.message);
    }

    setLoading(false);
  };
  const handleChangeUsername = () => {
    setStep(1);
    setOtpPassword('');
    setLoginError('');
    setCounter(120);
    setCanResend(false);
    setInfoText('لطفا برای ورود کد مشتری خود را وارد کنید');
  };
  useEffect(() => {
    if (step === 2) {
      document.getElementById('password')?.focus();
    }
  }, [step]);

  useEffect(() => {
    if (step === 1) {
      document.getElementById('username')?.focus();
    }
  }, [step]);
  useEffect(() => {
    if (step === 3) {
      document.getElementById('password-permanent')?.focus();
    }
  }, [step]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step !== 2) return;
    setLoginError('');
    setLoading(true); // Start loading

    try {

      const result = await login(username, otpPassword, changedPassword);
      if (result === 0) {
        // OTP valid, user is logged in, show password change step
        setStep(3);
      }

    } catch (error) {
      setLoginError(error.message);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const handleResend = async () => {
    setLoginError('');
    const result = await ResendPassword(username);
    if (result.success) {
      setStep(2)
      setCounter(120);
      setCanResend(false);
      setInfoText(`رمز عبور برای کد مشتری «${username}» ارسال شد.`);
    } else {
      setLoginError(result.message);
    }
  };

  return (
    <div className="authincation d-flex justify-content-center flex-column position-relative">
      <div className="authincation d-flex justify-content-center align-items-center flex-column">
        <div className="auth-form p-5 bg-white">
          <div className="text-center mb-2">
            <a href="index.html" className="d-block">
              <img src="Images/Logo.png" alt="img" className="login-img" />
            </a>
          </div>
          <h4 className="text-center mb-5">خوش آمدید!</h4>
          <p className="mb-4 text-muted transition-all">
            {infoText}
          </p>

          {loginError && (
            <div className="alert alert-danger text-center p-2">{loginError}</div>
          )}
          {success && (
            <div className="alert alert-success text-center p-2">
              {success}
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && step === 1) {
                e.preventDefault();   // جلوگیری از submit
                handleNextStep();     // رفتن به مرحله رمز
              }
            }}
            className="position-relative overflow-hidden"
          >

            {/* STEP 1 – کد مشتری */}
            <div
              className={`transition-all ${step === 1 ? 'show-step' : 'hide-step'}`}
            >
              <div className="mb-4">
                <label className="mb-1 text-muted fw-bold">کد مشتری</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleNextStep();
                    }
                  }}
                />
              </div>

              <button
                type="button"
                className="btn btn-danger w-100 fw-bold"
                onClick={handleNextStep}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'ورود'}
              </button>
            </div>
            {/* STEP 2 – رمز عبور */}
            <div
              className={`transition-all ${step === 2 ? 'show-step' : 'hide-step'}`}
            >
              <div className="mb-3">
                <label className="mb-1 text-muted fw-bold">رمز عبور</label>
                <div className="position-relative">
                  <input
                    type={showOtpPassword ? 'text' : 'password'}
                    className="form-control"
                    value={otpPassword}
                    autoComplete="one-time-code"
                    inputMode="numeric"
                    onChange={(e) => setOtpPassword(e.target.value)}
                  />
                  <span
                    className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                    onClick={() => setShowOtpPassword(prev => !prev)}
                    style={{ cursor: 'pointer' }}
                  >
                    {showOtpPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </span>
                </div>
                <div className="text-start mb-3">
                  <button
                    type="button"
                    onClick={handleChangeUsername}
                    className="btn btn-link p-0 text-decoration-none text-small text-muted"
                  >
                    تغییر کد مشتری
                  </button>
                </div>
              </div>

              {!canResend ? (
                <p className="text-center text-muted small mb-3">
                  دریافت نکردید؟ ارسال مجدد تا {formatTime(counter)}
                </p>
              ) : (
                <button
                  type="button"
                  className="btn btn-outline-danger w-100 mb-3"
                  onClick={handleResend}
                >
                  ارسال مجدد رمز عبور
                </button>
              )}

              <button
                type="submit"
                className="btn btn-danger w-100 fw-bold d-flex justify-content-center align-items-center"
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'ورود'}
              </button>
              <p className="text-center text-primary small mb-3 cursor-pointer mt-3"
                onClick={() => {
                  if (changedPassword === "1") {
                    setLoginError(''); 
                    setStep(3);        
                  }
                }}
              >
                ورود با رمز عبور
              </p>
            </div>
            {/* STEP 3 –  رمز عبور */}
            <div
              className={`transition-all ${step === 3 ? 'show-step' : 'hide-step'}`}
            >
              <div className="mb-3">
                <label className="mb-1 text-muted fw-bold">رمز عبور</label>
                <div className="position-relative mb-0">
                  <input
                    type={showPermanentPassword ? 'text' : 'password'}
                    className="form-control"
                    value={permanentPassword}
                    id="password-permanent"
                    onChange={(e) => setPermanentPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleLoginByUserPassword();
                      }
                    }}
                  />
                  <span
                    className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                    onClick={() => setShowPermanentPassword(prev => !prev)}
                    style={{ cursor: 'pointer' }}
                  >
                    {showPermanentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </span>
                </div>
                <div className="text-start mb-3">
                  <button
                    type="button"
                    onClick={handleChangeUsername}
                    className="btn btn-link p-0 text-decoration-none text-small text-muted"
                  >
                    تغییر کد مشتری
                  </button>
                </div>
                <div className="text-start mb-3">
                  <button
                    type="button"
                    onClick={handleLoginByUserPassword}
                    className="btn btn-danger w-100 fw-bold d-flex justify-content-center align-items-center mb-3"
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'ورود'}
                  </button>
                  <p className="text-center text-primary small mb-3 cursor-pointer" onClick={handleResend}>
                    ورود با رمز یک‌بار مصرف
                  </p>

                </div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default LoginPage;